app.directive('accountSelect', ['LocaleService', 'constants', 'Storage',
    function (LocaleService, Const, Storage) {
        return {
            scope: {
                accounts: '=',
                current: '=',
                user: '<',
                config: '<'
            },
            restrict: 'E',
            templateUrl: 'templates/directives/accountSelect.html',
            link: function (scope) {
                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });
                scope.constants = Const;
                scope.showCredit = Storage.get('allowCredit');
            }
        }
    }]);
